import { render, staticRenderFns } from "./SanitasTabItem.vue?vue&type=template&id=2783d7d6&scoped=true&"
import script from "./SanitasTabItem.vue?vue&type=script&lang=js&"
export * from "./SanitasTabItem.vue?vue&type=script&lang=js&"
import style0 from "./SanitasTabItem.vue?vue&type=style&index=0&id=2783d7d6&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783d7d6",
  null
  
)

export default component.exports